/* eslint-disable arrow-body-style */
/* eslint-disable no-useless-return */
/* eslint-disable no-unreachable */
/* eslint-disable no-useless-catch */
import get from 'lodash/get';
import { BusinessDetails, BusinessLevels, BuzzDataType } from '../common/types';

import { API_END_POINTS } from '../config/api-endpoints';
import { callApi } from "../common/api";

export const getHierarchy = async () => {
  return;
  const headers = {
    'X-Cleartax-Product': 'EInvoice',
    // 'X-Cleartax-Auth-Token':
    //   '1.a242d79a-cecc-4420-b61e-58b5628cdd1f_f490174e6f474eb2526ed1737eb6cf50c80a2e86e97416bbd4d4a9c45d284c56',
  };
  const response = await callApi({
    method: 'GET',
    url: API_END_POINTS.SETTINGS.HIERARCHY,
    headers,
  });
  return response;
};

export const getHierarchyAuthz3 = async (nodeType: string, nodeId: string) => {
  return;
  const headers = {
    'X-Cleartax-Product': 'EInvoice',
  };
  const response = await callApi({
    method: 'GET',
    params: {
      nodeType,
      nodeId,
    },
    url: API_END_POINTS.AUTHZ3.HIERARCHY,
    headers,
  });
  return response;
};

export const getWorkspaces = async () => {
  const headers = {
    'X-Cleartax-Product': 'EInvoice',
  };
  const response = await callApi({
    method: 'GET',
    url: API_END_POINTS.AUTHZ3.WORKSPACES,
    headers,
  });
  return response;
};

const entityNameMap = {
  [BusinessLevels.PAN]: 'pan',
  [BusinessLevels.GSTIN]: 'gstin',
};

export const mapBackendDataToBusinessDetails = (element: BuzzDataType) => {
  const { level, id, name, parentOrgUnitId, canAccess = true } = element;
  const newName =
    level === BusinessLevels.BRANCH
      ? name
      : get(element, 'metadata.displayname') || name;
  const rowObj: BusinessDetails = {
    id,
    entityName: newName,
    name: newName,
    canAccess,
    __children: [],
    childIds: [],
    level,
    parentOrgUnitId,
    identifier: level === BusinessLevels.BRANCH ? undefined : name,
    metadata: get(element, 'metadata', {}),
  };

  // @ts-ignore
  const key = entityNameMap[level];
  if (key) {
    // @ts-ignore
    rowObj[key] = element.name;
  }
  return rowObj;
};

export const transformToOldAuthz = (resData: any) => {
  let retData: any = [];
  const orgs = resData.workspaceNodes.map((d: any) => d.organisations);
  const pans = orgs[0].map((d: any) => d.pans);
  if (pans && pans.length) {
    retData = retData.concat(...pans);
  }
  const gstins = pans[0].map((d: any) => d.gstins);
  if (gstins && gstins.length) {
    retData = retData.concat(...gstins);
    const branches = gstins[0].map((d: any) => d.branches);
    if (branches && branches.length) {
      retData = retData.concat(...branches);
    }
  }
  for (let index = 0; index < retData.length; index++) {
    retData[index].canAccess = retData[index].isAccessible;
    retData[index].level = retData[index].nodeType;
    retData[index].parentOrgUnitId = retData[index].parentId;
    retData[index].metadata = {
      ...retData[index].metadata,
      displayname: retData[index].name,
    };
    if (retData[index].identifier) {
      retData[index].name = retData[index].identifier;
    }

  }
  return retData;
};

export const convertAllBusinessGridResponseToGridData = (data: any) => {
  const panDbLocal: any = [];
  const dataStore: any = {};
  const gridData: BusinessDetails[] = [];
  data.forEach((element: any) => {
    const { level, id } = element;
    const rowObj = mapBackendDataToBusinessDetails(element);
    if (level === BusinessLevels.PAN) {
      gridData.push(rowObj);
      panDbLocal.push(id);
    }
    dataStore[id] = rowObj;
  });
  data.forEach((element: any) => {
    const { id, parentOrgUnitId } = element;
    const rowObj = dataStore[id];
    const parent: any = dataStore[parentOrgUnitId];
    if (parentOrgUnitId && parent) {
      parent.__children.push(rowObj);
      parent.childIds.push(id);
    }
  });
  return { data: gridData, panDb: panDbLocal, businessDataStore: dataStore };
};

// eslint-disable-next-line consistent-return
export const getBusinessList = async () => {
  return;
  // try {
  //   const response = await getHierarchy();
  //   const {
  //     panDb,
  //     businessDataStore,
  //     data,
  //   } = convertAllBusinessGridResponseToGridData(response.data || []);
  //   return { panDb, businessDataStore, data };
  // } catch (e) {
  //  //  console.log(e);
  //   throw e;
  // }
};

// eslint-disable-next-line consistent-return
// eslint-disable-next-line max-len
export const getBusinessListAuthz3 = async (nodeType: string, nodeId: string) => {
  return;
  // try {
  //   const response = await getHierarchyAuthz3(nodeType, nodeId);
  //   const transformedData = transformToOldAuthz(response.data);
  //   const {
  //     panDb,
  //     businessDataStore,
  //     data,
  //   } = convertAllBusinessGridResponseToGridData(transformedData || []);
  //   return { panDb, businessDataStore, data };
  // } catch (e) {
  //  //  console.log(e);
  //   throw e;
  // }
};